import { render, staticRenderFns } from "./ExcludeObjectsDialog.vue?vue&type=template&id=0535dd7c&scoped=true&"
import script from "./ExcludeObjectsDialog.vue?vue&type=script&lang=ts&"
export * from "./ExcludeObjectsDialog.vue?vue&type=script&lang=ts&"
import style0 from "./ExcludeObjectsDialog.vue?vue&type=style&index=0&id=0535dd7c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0535dd7c",
  null
  
)

export default component.exports